module.exports = __webpack_public_path__ + "assets/img/HR-Connect-Website-w540.4b961f41.webp";